/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown>, metric: NonNullable<unknown>, days: NonNullable<unknown> }} Perks_Trigger_Stat_OneInputs */



/**
* | output |
* | --- |
* | "{min} {metric} in {days} day" |
*
* @param {Perks_Trigger_Stat_OneInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_trigger_stat_one = /** @type {((inputs: Perks_Trigger_Stat_OneInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Trigger_Stat_OneInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.min} ${i?.metric} за ${i?.days} день`)
	return /** @type {LocalizedString} */ (`${i?.min} ${i?.metric} in ${i?.days} day`)
});